/* eslint-disable max-len */
const React = require('react');
const PointMobileEs = require('./pointMobileES');
const PointMobilePT = require('./pointMobilePT');
const PointMobileREPT = require('./pointMobileREPT');
const PointMobileREES = require('./pointMobileREES');
const PointMobileMLA = require('./pointMobileMLA');

const PointMobile = {
  es: PointMobileEs,
  pt: PointMobilePT,
  en: PointMobileEs,
  're-pt': PointMobileREPT,
  're-es': PointMobileREES,
  're-en': PointMobileREES,
  mla: PointMobileMLA,
};

module.exports = PointMobile;
